import { useMonarchTestResult } from "../../useMonarchTestResult";
import { useMonarchRule } from "../MonarchRulesProvider";
import {
  HomepageLOBEntrypointsTestProps,
  HomepageLOBEntrypointsTestResult,
  HomepageLOBEntrypointsTestVariant,
} from "./types";

const CUSTOM_RULE_ID = "homepageLobEntrypoints";

export default function useExecEdDetailPageTest(): HomepageLOBEntrypointsTestResult {
  const { isLoading, value } = useMonarchRule<{
    data: HomepageLOBEntrypointsTestProps;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading) {
    return {
      isLoading,
      variant: "control" as HomepageLOBEntrypointsTestVariant,
      data: {
        header: "",
        subheader: "",
        showEntrypoints: false,
        backgroundColor: "white",
        showcaseCards: [],
      },
    };
  }

  const variant = value?.data?.header ? "test" : "control";

  return {
    isLoading,
    variant: variant as HomepageLOBEntrypointsTestVariant,
    data: {
      header: value?.data?.header || "",
      subheader: value?.data?.subheader || "",
      showEntrypoints: value?.data?.showEntrypoints || false,
      backgroundColor: value?.data?.backgroundColor || "white",
      showcaseCards:
        value?.data?.showcaseCards?.map((card) => {
          return {
            header: card?.header || "",
            subheader: card?.subheader || "",
            headerBackgroundColor: card?.headerBackgroundColor || "putty",
            headerIcon: card?.headerIcon || "book-open",
            factoids: card?.factoids || [],
            cta: card?.cta || {
              text: "",
              url: "",
            },
            hideFactoidsOnMobile: card?.hideFactoidsOnMobile || false,
          };
        }) || [],
    },
  };
}
